var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCurrency = function SvgCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.39 8.17A1.85 1.85 0 0114 9.33h1.72a3.74 3.74 0 00-1.15-2.55A3.34 3.34 0 0012.7 6V4H11v2a4.45 4.45 0 00-1.83.81A3.14 3.14 0 008 9.33a3.74 3.74 0 001.15 2.55 4.3 4.3 0 002.64.93 2.72 2.72 0 011.6.58 1.85 1.85 0 01.61 1.16 1.43 1.43 0 01-.57 1.16 2.56 2.56 0 01-3.09 0 1.85 1.85 0 01-.57-1.16H8a3.74 3.74 0 001.15 2.55A4.59 4.59 0 0011 18v2h1.7v-2a4 4 0 001.83-.93 3.14 3.14 0 001.15-2.55A3.74 3.74 0 0014.53 12a4.3 4.3 0 00-2.64-.93 2.72 2.72 0 01-1.6-.58 1.85 1.85 0 01-.57-1.16 1.62 1.62 0 01.57-1.16 2.56 2.56 0 013.1 0z"
  })));
};

export default SvgCurrency;